// extracted by mini-css-extract-plugin
module.exports = {"root":"ContactButton_root__1GpvY","icon":"ContactButton_icon__3cBGU"};